import ListagemItens from "../../componentes/ListagemItens";

function Inicio() {
    return (
        <ListagemItens />
    )
}

export default Inicio;